import { Component, OnInit, Inject } from '@angular/core';
import { Messages } from 'src/app/constants/messages';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SnackbarService } from 'src/app/snackbar.service';
import { ValidationService } from 'src/app/validation.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.scss']
})
export class SendEmailComponent implements OnInit {
  track;
  email = '';
  emailArray;
  messages = new Messages();
  constructor(
    @Inject(MAT_DIALOG_DATA) private parentData: any, private dialog: MatDialogRef<SendEmailComponent>,
    private snackbar: SnackbarService,private validationService:ValidationService,private http: HttpService) { }

  ngOnInit() {
    this.track = this.parentData.trackingUrl;
  }
  closeModal() {
    this.dialog.close();
  }

  //validate email
  validate(){
    let valid = true;
    for(let i = 0; i<this.emailArray.length;i++){
      if(!this.validationService.isEmail(this.emailArray[i])){
        valid = false;
        this.snackbar.openSnackBar(this.messages.SEND_EMAIL.ERROR.EMAIL_ID+':'+this.emailArray[i],'','err');
        break;
      }
    }
    return valid;
  }
  //send email
  sendEmail() {
    this.emailArray = this.email.split(',');//multiple email addresses
    const dataToSend: any = {
      shipment_id: this.parentData.id,
      email_Ids: this.emailArray
    }
    if (this.validate()) {
      this.http.post('shipment/send_track_link', dataToSend).subscribe(
        (data: any) => {
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar(this.messages.SEND_EMAIL.SUCCESS.EMAIL_SENT);
          this.closeModal();
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
      );
    }
  }
}
